import { IPlane, IVector3 } from '@inter-ikea-betrakta/viewer';
import { ComponentIds } from '@inter-ikea-core/core';
import { HideDrawerFrontComponent } from '../..';
import { PlannerEcsSystem } from './System';
export class HideDrawerFrontSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'HideDrawerFrontSystem', HideDrawerFrontComponent.id);
    }
    onAdd(entity) {
        const entityObjectId = this.coreApi.entities.getObjectId(entity);
        const model = entity.getComponent(ComponentIds.LOADED_MODEL_INFO_COMPONENT_ID);
        if (!model?.hasFinishedLoading) {
            return;
        }
        if (entityObjectId && model.hasFinishedLoading) {
            const normal = { x: 0, y: 0, z: 1 };
            const plane = new IPlane(normal, IVector3.scale(normal, this.getClipDistance(entity)));
            this.coreApi.ipexViewer.set_object_clip_plane(entityObjectId, plane);
        }
    }
    // Clip distance is based on component center and outwards towards front.
    getClipDistance(entity) {
        const size = entity.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)?.size;
        if (size) {
            return size.depth / 2000 - 0.05; //Get half of component depth in meters and remove 5 cm.
        }
        return 0;
    }
    onUpdate() { }
    onRemove(entity) {
        const entityObjectId = this.coreApi.entities.getObjectId(entity);
        if (entityObjectId) {
            this.coreApi.ipexViewer.set_object_clip_plane(entityObjectId, null);
        }
    }
}
//# sourceMappingURL=HideDrawerFrontSystem.js.map